import { useBirthdayOptions } from '@zealth/core/formFields/useBirthdayOptions'

import { DateFormField } from './DateFormField'

export const BirthdayFormField = () => {
  const { minDate, maxDate } = useBirthdayOptions()

  return (
    <DateFormField
      label="Birthday"
      minDate={minDate}
      maxDate={maxDate}
      mode="year_month"
      defaultDay={2}
    />
  )
}
